
// import _ from 'lodash';

const namespaced = true;

const state = {
  reloadKey: null,
  dbClients: [],
  dbStatuses: [],
  dbSites: [],
  dbSitesByMaker: {},
  dbPrioritiesByMaker: {},
  dbDomainsByMaker: {},
  dbMakerUsers: [],
  makers: [],
  client: {},
  site: {},
  tags: [],
  availableEquipments: [],
  floor: ``,
  room: ``,
  placeDetails: ``,
  title: ``,
  description: ``,
  priority: {},
  domain: {},
  equipments: [],
  inboxIntervention: {},
};

const mutations = {
  SET_RELOAD_KEY(state, reloadKey) {
    state.reloadKey = reloadKey;
  },
  SET_DB_CLIENTS(state, dbClients) {
    state.dbClients = dbClients;
  },
  SET_DB_STATUSES(state, dbStatuses) {
    state.dbStatuses = dbStatuses;
  },
  SET_DB_SITES(state, sites) {
    state.dbSites = sites;
  },
  SET_DB_SITES_BY_MAKER(state, dbSitesByMaker) {
    state.dbSitesByMaker = dbSitesByMaker;
  },
  SET_DB_PRIORITIES_BY_MAKER(state, dbPrioritiesByMaker) {
    state.dbPrioritiesByMaker = dbPrioritiesByMaker;
  },
  SET_DB_DOMAINS_BY_MAKER(state, dbDomainsByMaker) {
    state.dbDomainsByMaker = dbDomainsByMaker;
  },
  SET_DB_MAKER_USERS(state, dbMakerUsers) {
    state.dbMakerUsers = dbMakerUsers;
  },
  SET_MAKERS(state, makers) {
    state.makers = makers;
  },
  SET_CLIENT(state, client) {
    state.client = client;
  },
  SET_SITE(state, site) {
    state.site = site;
  },
  SET_TAGS(state, tags) {
    state.tags = tags;
  },
  SET_AVAILABLE_EQUIPMENTS(state, equipments) {
    state.availableEquipments = equipments;
  },
  SET_FLOOR(state, floor) {
    state.floor = floor;
  },
  SET_ROOM(state, room) {
    state.room = room;
  },
  SET_PLACE_DETAILS(state, placeDetails) {
    state.placeDetails = placeDetails;
  },
  SET_TITLE(state, title) {
    state.title = title;
  },
  SET_DESCRIPTION(state, description) {
    state.description = description;
  },
  SET_PRIORITY(state, priority) {
    state.priority = priority;
  },
  SET_DOMAIN(state, domain) {
    state.domain = domain;
  },
  SET_EQUIPMENTS(state, equipments) {
    state.equipments = equipments;
  },
  SET_INBOX_INTERVENTION(state, inboxIntervention) {
    state.inboxIntervention = inboxIntervention;
  },
};

const actions = {
  changeReloadKey({ commit }) {
    commit(`SET_RELOAD_KEY`, Date.now());
  },
  async fetchClients({
    state, commit, dispatch, rootState,
  }) {
    const { company } = rootState[`model/client`];
    // const { isMaker, company } = rootState[`model/client`];
    let clients = [];
    if (state.makers.length) {
      clients = await dispatch(`model/client/fetchListForMaker`, state.makers[0].id, { root: true });
    } else {
      // clients = _.filter(clients, client => client.id === company.id);
      clients = [company];
    }

    commit(`SET_DB_CLIENTS`, clients);
  },
  async fetchStatuses({ state, commit, dispatch }) {
    const statuses = await dispatch(`model/status/fetchListForMaker`, state.makers[0].id, { root: true });

    commit(`SET_DB_STATUSES`, statuses);
  },
  async fetchSites({
    state, commit, dispatch, rootState,
  }) {
    const { isMaker } = rootState[`model/client`];
    if (!isMaker) {
      const sites = await dispatch(`model/site/fetchSitesForClientWithClientTags`, state.client.id, { root: true });

      commit(`SET_DB_SITES`, sites);
    } else {
      const firstMaker = state.makers[0];
      const sites = await dispatch(`model/site/fetchSitesForMakerAndClient`, { makerId: firstMaker.id, clientId: state.client.id }, { root: true });
      const sitesByMaker = {};
      state.makers.forEach(maker => {
        sitesByMaker[maker.id] = sites;
      });

      commit(`SET_DB_SITES_BY_MAKER`, sitesByMaker);
    }
  },
  async fetchPriorities({ state, commit, dispatch }) {
    const prioritiesByMaker = {};
    await Promise.all(state.makers.map(async maker => {
      const priorities = await dispatch(`model/priority/fetchPrioritiesForMaker`, maker.id, { root: true });
      prioritiesByMaker[maker.id] = priorities;
    }));

    commit(`SET_DB_PRIORITIES_BY_MAKER`, prioritiesByMaker);
  },
  async fetchDomains({ state, commit, dispatch }) {
    const domainsByMaker = {};
    await Promise.all(state.makers.map(async maker => {
      const domains = await dispatch(`model/domain/fetchDomainsForMaker`, maker.id, { root: true });
      domainsByMaker[maker.id] = domains;
    }));

    commit(`SET_DB_DOMAINS_BY_MAKER`, domainsByMaker);
  },
  async fetchMakerUsers({ state, commit, dispatch }) {
    // const domainsByMaker = {};
    // for (const maker of state.maker) {
    //   const domains = await dispatch(`model/user/fetchUsersForMaker`, maker.id, { root: true });
    //   domainsByMaker[maker.id] = domains;
    // }
    const makerUsers = await dispatch(`model/user/fetchUsersForClient`, state.makers[0].id, { root: true });

    commit(`SET_DB_MAKER_USERS`, makerUsers);
  },
  async fetchAvailableEquipments({
    state, commit, dispatch, getters,
  }) {
    const queryParams = {
      maker: getters.firstMaker.id,
      client: state.client.id,
      site: state.site.id,
      viewAll: 1,
    };
    const equipments = await dispatch(`model/equipment/fetchList`, {
      queryParams,
    }, { root: true });

    commit(`SET_AVAILABLE_EQUIPMENTS`, equipments);
  },
  async fetchTags({ commit, dispatch, rootState }) {
    commit(`SET_TAGS`, []);
    const client = rootState[`model/client`].company;
    let tags = [];
    if (client.isRoot) {
      tags = await dispatch(`model/tag/fetchForMaker`, client.id, { root: true });
    } else {
      tags = await dispatch(`model/tag/fetchForClient`, client.id, { root: true });
    }

    commit(`SET_TAGS`, tags);
    return tags;
  },
  async checkIfMakerHasEmail({ state, getters, dispatch }) {
    const { firstMaker } = getters;

    if (state.makers.length > 1 || !firstMaker) {
      return true;
    }

    const hasEmail = await dispatch(`model/maker/checkIfHasEmail`, firstMaker.id, { root: true });

    return hasEmail === true;
  },
  async markInboxInterventionAccepted({ state, dispatch }) {
    try {
      await dispatch(`model/inboxIntervention/markAccepted`, state.inboxIntervention.id, { root: true });
      dispatch(`ui/mainLayout/fetchCountInboxInterventions`, null, { root: true });
    } catch (e) {} // eslint-disable-line
  },
};

const getters = {
  firstMaker(state) {
    return state.makers[0] || null;
  },
  sites(state, getters, rootState) {
    const { isMaker } = rootState[`model/client`];
    if (isMaker) {
      const firstMaker = state.makers[0];
      return state.dbSitesByMaker[firstMaker.id];
    }
    return state.dbSites;
  },
  isAggregatorClient(state) {
    return Boolean(state.client && state.client.slug && state.client.slug.length);
  },
  isRealEstateClient(state, getters) {
    return Boolean(getters.isAggregatorClient && state.client.isRealEstate);
  },
  hasInboxIntervention: state => Boolean(state.inboxIntervention && state.inboxIntervention.id),
  isCreatingAsClient: (state, getters, rootState) => state.client.id === rootState[`model/client`].company.id,
  isCreatingAsMaker: (state, getters) => !getters.isCreatingAsClient,
};

export default {
  namespaced, state, mutations, actions, getters,
};
